import { FeedbackFormDialog } from '@colonist/clientforge';
import { FeedbackFormLocationEnum } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { FeedbackFormDataValidate } from '../../../../../shared/feedback_form/FeedbackFormDataValidate.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
import { uiGameManager } from '../../EntryShared.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { ClientUserState } from '../../ClientUserState.ts';
import { showTranslucentOverlay } from '../../ui_overlays/showTranslucentOverlay.ts';
const renderFeedbackFormDialog = mountDialogUIReactComponent(FeedbackFormDialog);
export function showFeedbackForm(gameId, location, onFinish) {
    var _ClientUserState_userState;
    StorageWrapper.setLastFeedbackFormDate(new Date());
    const handleSubmit = async (data)=>{
        const formData = {
            gameId: gameId,
            location: location,
            rate: data.rate,
            feedback: data.feedback,
            email: data.email,
            skipped: data.skipped
        };
        if (location == FeedbackFormLocationEnum.Homepage && FeedbackFormDataValidate.isEmpty(formData)) {
            onFinish();
            return;
        }
        try {
            FeedbackFormDataValidate.validate(formData);
        } catch (err) {
            showTranslucentOverlay({
                title: {
                    key: 'strings:popups.errors.general.title'
                },
                body: {
                    key: 'strings:colonistCommon.utils.#buffer',
                    options: {
                        value: err.message
                    }
                },
                onConfirm: ()=>onFinish()
            });
            return;
        }
        await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiFeedbackFormSubmit(), undefined, formData, 'application/json');
        uiGameManager.eventController.sendEvent(formData.rate, GameStateEnums.UIGameEventEnums.FeedbackFormSubmitted);
        onFinish();
    };
    var _ClientUserState_userState_isLoggedIn;
    const isLoggedIn = (_ClientUserState_userState_isLoggedIn = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) !== null && _ClientUserState_userState_isLoggedIn !== void 0 ? _ClientUserState_userState_isLoggedIn : false;
    renderFeedbackFormDialog({
        onSubmit: (data)=>void handleSubmit(data),
        isLoggedIn: isLoggedIn
    });
}
